'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var keyConstants = exports.keyConstants = {
  AND: 'and',
  OR: 'or',
  GROUP: 'group',
  EQUALS: 'equals',
  NOT_EQUALS: 'not_equals',
  LESS_THAN: 'less_than',
  LESS_THAN_OR_EQUAL: 'less_than_or_equal',
  GREATER_THAN: 'greater_than',
  GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
  IN: 'in',
  OUT: 'out',
  CUSTOM_OPERATOR: 'custom_operator',
  CUSTOM_EXPRESSION: 'custom_expression'
};